import React from 'react';

export const states = {
  default: '',
  warning: 'warning',
  cancel: 'cancel',
  edit: 'edit',
};

export const StateContext = React.createContext(states.default);
